// Import Core
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
// Import Components
import SimpleContent from './SimpleContent';
import TwoColInfoCard from './TwoColInfoCard';
import NewsletterCta from './ctas/NewsletterCta';
import FiveCardGrid from './FiveCardGrid';
import ThreeCardGrid from './ThreeCardGrid';
import FeaturedImageSlider from './FeaturedImageSlider';
import DefaultCards from './DefaultCards';
import TailorMadeHolidaysCardCarousel from './carousel/TailorMadeHolidaysCardCarousel';
import StaffReviewsCardCarousel from './carousel/ReviewsCardCarousel';
import PopularDestinationsCardCarousel from './carousel/PopularDestinationsCardCarousel';
import AutoAttractionsCardCarousel from './carousel/AutoAttractionsCardCarousel';
import SpecialOffersCardCarousel from './carousel/SpecialOffersCardCarousel';
import CulturalToursCardCarousel from './carousel/CulturalToursCardCarousel';
import AccordionDetailed from './AccordionDetailed';
import Separator from '../ui/Separator';
import ShortBreaksCardCarousel from './carousel/ShortBreaksCarousel';
import TableBlock from './TableBlock';
import CustomCardCarousel from "./carousel/CustomCardCarousel";
import VideoBlock from "./VideoBlock";

// Import configData
import configData from '../../../configData.json'; 

const SinglePageFlexibleContentStyling = styled.div`
	width: inherit;
`;

/* Render Component */
const SinglePageFlexibleContent = ({ pageContent }) => {
	{
		/* 
		simpleContent 
		tableBlock
		featuredImageSlider
		cardCarousel
		accordion
		defaultCards
		newsletterFormBlock
		twoColInfoCard
		threeCardGrid
		fiveCardGrid
		*/
	}
	const [pageSections, setPageSections] = useState([]);
	useEffect(() => {
		setPageSections(pageContent);
	}, []);
	// if no returned from query return null so there are no errors
	if (!pageContent) {
		return null;
	}

	return (
		<>
			{pageSections.map((section, index) => {
				// console.log("🚀 ~ file: SinglePageFlexibleContent.js:44 ~ {pageSections.map ~ section:", section);
				return (
					<SinglePageFlexibleContentStyling  key={`${section.name}-${index}`} className='page-max-width'>
						
						{section._type === 'accordion' && (
							<AccordionDetailed
								addToAnchor={section.addToAnchor}
								title={section.title}
								items={section.accordionItems}
							/>
						)}

						{/*  Card Carousel - Tailor Made Holidays */}
						{section._type === 'cardCarousel' && section.cptType === 'tailorMadeHolidays' && (
							<TailorMadeHolidaysCardCarousel section={section} />
						)}

						{/* Card Carousel -  Cultural Tours */}
						{section._type === 'cardCarousel' && section.cptType === 'culturalTours' && (
							<CulturalToursCardCarousel section={section} />
            )}

						{/* Card Carousel - Attractions */}
						{section._type === 'cardCarousel' && section.cptType === 'attractions' && (
							<AutoAttractionsCardCarousel section={section} />
            )}

						{/* Card Carousel - Special Offers */}
						{section._type === 'cardCarousel' && section.cptType === 'specialOffers' && (
							<SpecialOffersCardCarousel section={section} />
            )}

						{/*  Card Carousel - Reviews */}
						{(section._type === 'cardCarousel' && section.cptType === 'reviews') && (
							<StaffReviewsCardCarousel section={section} />
						)}

						{section._type === "customCardCarousel" && (
							<CustomCardCarousel section={section} />
						)}

						{/*  Card Carousel - Short Breaks */}
						{section._type === 'cardCarousel' && section.cptType === 'hotelBreaks' && (
              <ShortBreaksCardCarousel section={section} />
            )}

						{/*  Card Carousel - Popular Destinations */}
						{section._type === 'cardCarousel' && section.cptType === 'popularDestinations' && (
							<PopularDestinationsCardCarousel section={section} />
						)}

						{/* FOLLOW UP:  Card Carousel - Blog Posts */}
						{/* {section._type === 'cardCarousel' && section.cptType === 'blogPosts' && (
							<p>_type: {section._type}, cptType: {section.cptType}</p>
            )} */}
						{/* FOLLOW UP:  Card Carousel - Countries */}
						{/* {section._type === 'cardCarousel' && section.cptType === 'countries' && (
							<p>_type: {section._type}, cptType: {section.cptType}</p>
            )} */}
						{/* FOLLOW UP:  Card Carousel - Regions */}
						{/* {section._type === 'cardCarousel' && section.cptType === 'regions' && (
							<p>_type: {section._type}, cptType: {section.cptType}</p>
            )} */}
						{/* FOLLOW UP:  Card Carousel - Cities */}
						{/* {section._type === 'cardCarousel' && section.cptType === 'cities' && (
							<p>_type: {section._type}, cptType: {section.cptType}</p>
            )} */}

						{section._type === 'defaultCards' && (
							<DefaultCards
								addToAnchor={section.addToAnchor}
								sectionTitle={section.sectionTitle}
								cards={section.cards}
							/>
						)}

						{section._type === 'featuredImageSlider' && (
							<FeaturedImageSlider
								addToAnchor={section.addToAnchor}
								images={section.images}
							/>
						)}

						{section._type === 'fiveCardGrid' && (
							<FiveCardGrid
								addToAnchor={section.addToAnchor}
								subheading={section.sectionTitle.subheading}
								title={section.sectionTitle.title}
								caption={section.sectionTitle.caption}
								navItem={section.navItem}
								navItem2={section.navItem2}
								people={section.personType === 'artist' ? section.assignedArtists : section.assignedTourLeaders}
							/>
						)}

						{section._type === 'newsletterFormBlock' && (
							<NewsletterCta
								title={configData.enquiry.newsletter.text}
								content={configData.enquiry.newsletter.content}
								ctaStyle='white'
							/>
						)}

						{section._type === 'separator' && (
							<Separator color={section.separatorStyle} />
						)}

						{section._type === 'simpleContent' && (
							<SimpleContent
								content={section.simpleContentText}
								addToAnchor={section.addToAnchor}
								anchorTitle={section.anchorTitle}
							/>
						)}

						{section._type === 'tableBlock' && (
							<TableBlock
								addToAnchor={section.addToAnchor}
								tableTitle={section.tableTitle}
								tableCaption={section.tableCaption}
								addTableHeaders={section.addTableHeaders}
								table={section.table}
							/>
						)}

						{section._type === 'threeCardGrid' && (
							<ThreeCardGrid
								addToAnchor={section.addToAnchor}
								sectionTitle={section.sectionTitle}
								subtitle={section.subtitle}
								description={section.description}
								cards={section.cards}
								title={section.title}
								content={section.content}
								image={section.image}
							/>
						)}

						{section._type === 'twoColInfoCard' && (
							<TwoColInfoCard
								addToAnchor={section.addToAnchor}
								subheading={section.sectionTitle.subheading}
								title={section.sectionTitle.title}
								caption={section.sectionTitle.caption}
								image={section.image}
							/>
						)}

						{section._type === "videoBlock" && (
							<VideoBlock
								videoSectionTitle={section.videoSectionTitle}
								videoSectionSubheading={section.videoSectionSubheading}
								videoSectionDescription={section.videoSectionDescription}
								addToAnchor={section.addToAnchor}
								anchorTitle={section.anchorTitle}
								videos={section.videos}
							/>
						)}

					</SinglePageFlexibleContentStyling>
				);
			})}
		</>
	);
};

export default SinglePageFlexibleContent;
